//设备
import {getLanguageStr} from "@/util/language"

const state = {
    currentIndex: 0
}
const getters = {
    currentIndex: state => {
        return state.currentIndex
    }
}
const actions = {
}
const mutations = {
    SET_CURRENTINDEX: (state, index) => {
        state.currentIndex = index
    },
}
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/deviceDetail.js